
    
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ArrangeForServiceWrInstructions extends Vue {    

    @Prop({required: true})
    instructionsStep!: string;

    @Prop({required: true})
    applicationName!: string;
    
}
